import React, { useEffect, useState } from 'react'
import Grid from '@material-ui/core/Grid'
import Button from '@material-ui/core/Button'
import DropzoneS3Uploader from './DropzoneS3Uploader'
import { Field, change } from 'redux-form'

import { useDispatch, connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import { useTheme } from '@material-ui/core/styles'
import { compose } from 'recompose'
import { stopSaving } from '../redux/actions'

const progressBarStyle = {
    position: "relative",
    height: "16px",
    backgroundColor: "#e3eefe",
    margin: "10px 10px 20px",
    borderRadius: "10px"
};


const S3FileUploader = ({ question, name, bucketUrl, disabled, intl, form, changeAnswer, onBlur, defaultShowValue, ...rest }) => {

    const [showValue, setShowValue] = useState(defaultShowValue)

    useEffect(
		() => {
            setShowValue(defaultShowValue)
        },
        [defaultShowValue]
    )

    const theme = useTheme()

    let onFinishHandler = data => {
        setShowValue(true)
        let i = document.getElementById(name);

        i.setAttribute('data-fileKey', data.fileKey);
        i.setAttribute('data-fileName', data.file.name);
        i.setAttribute('data-fileLength', data.file.size);
        i.setAttribute('data-mime', data.file.type);
        i.setAttribute('data-changed', true);

        changeAnswer(form, data.fileUrl);

        onBlur();
    }

    let onError = data => {
        changeAnswer(form, null);
    }

    let getMaxSizeMb = () => {
        return 100;
    }

    let getAccept = () => {
        switch (question.questionType) {
            case 10:
                return "image/*";
            case 11:
                return "application/pdf";
            default:
                throw `Type ${question.questionType} not defined`;
        }
    }

    const uploadOptions = {
        server: '/api/file',
    }

    let getUploadFileDescriptionKey = () => {
        switch (question.questionType) {
        case 10:
            return 'app.questions.questionType.image.upload';
        case 11:
            return 'app.questions.questionType.pdf.upload';
        default:
            throw `Type ${question.questionType} not defined`;
        }
    }

    return (
        <DropzoneS3Uploader
            data-testid='dropzone-uploader'
            onFinish={onFinishHandler}
            onError={onError}
            s3Url={bucketUrl}
            maxSize={getMaxSizeMb() * 1024 * 1024}
            accept={getAccept()}
            upload={uploadOptions}
            progressComponent={progressBar}
            intl={intl}
            disabled={disabled}
            showValue={showValue}>
            <div className="file-question-wrapper">
                <div style={{
                    lineHeight: 1.23,
                    letterSpacing: '2.08px',
                    color: 'rgba(0, 0, 0, 0.6)',
                    marginBottom: '10px'
                }}>
                    {intl.formatMessage({ id: getUploadFileDescriptionKey() })}
                </div>
                <Button
                    data-testid='button-choose-file'
                    variant="contained"
                    color='primary'
                    disabled={disabled}
                >
                    {intl.formatMessage({ id: 'app.general.chooseFile' })}
                </Button>
            </div>
        </DropzoneS3Uploader>
    );
}

const progressBar = p => {
    return (
        p.progress > 0 &&
            <div className="progress-bar" style={progressBarStyle}>
            <div className="filler" style={{
                width: `${p.progress}%`,
                height: "100%",
                backgroundColor: "#007aff",
                backgroundSize: "50px 50px",
                boxShadow: "inset 0 -1px 1px rgba(255,255,255,0.3)",
                backgroundImage: "linear-gradient(-45deg, rgba(255, 255, 255, .2) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .2) 50%, rgba(255, 255, 255, .2) 75%, transparent 75%, transparent)",
                transition: "width .2s ease-in",
                borderRadius: "inherit"
            }} />
        </div>);
}

const FileQuestion = ({
    question,
    position,
    positionDisplay,
    value,
    validate,
    counter,
    displayCount,
    disabled,
    intl,
    changeAnswer,
    inputName,
    ...rest
}) => {
    let name = inputName ?? `answers.file._${question.uniqueId}`;

    return (<Field data-testid='file-dropzone-field-input' name={name} validate={validate} intl={intl} question={question} customDisabled={disabled} changeAnswer={changeAnswer} component={FileInputField} />)
}

const FileInputField = ({ input, question, changeAnswer, customDisabled, intl, label, type, meta: { form, touched, error, warning } }) =>
(
    <Grid data-testid='file-uploader-wrapper'>
        <S3FileUploader
            name={input.name}
            question={question}
            bucketUrl={question.tempBucketUrl}
            intl={intl}
            form={form}
            changeAnswer={changeAnswer}
            disabled={customDisabled}
            onBlur={input.onBlur}
            defaultShowValue={!!input.value}
        />
        <input {...input}
            data-testid='file-uploader-input'
            type="hidden"
            className="file-question"
            id={input.name}
            name={input.name}
            onBlur={input.onBlur}
            onChange={input.onChange}
            data-questionId={question.uniqueId}
            data-column={question.column}
            data-fileLength
            data-fileName
            data-mime
        />
        {touched && error && <span className="errorWrapper">{error}</span>}
    </Grid>
)

const mapStateToProps = (state, ownProps) => ({
})

const mapDispatchToProps = (dispatch, ownProps) => ({
    changeAnswer: (form, url) => {
        dispatch(change(form, ownProps.inputName ?? `answers.file._${ownProps.question.uniqueId}`, url))
    }
})

const enhance = compose(
    connect(mapStateToProps, mapDispatchToProps),
    injectIntl
)

export default enhance(FileQuestion)
